import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  ViewChildren,
  QueryList,
  OnDestroy,
  Inject, ElementRef, AfterViewChecked, HostListener,
  ViewContainerRef
} from '@angular/core';
import {AddlinkService} from '../../addlink.service';
import {RemarksModalComponent} from '../../shared/components/modals/remarks-modal/remarks-modal.component';
import {EditIndexKeyModalComponent} from '../../shared/components/modals/edit-index-key-modal/edit-index-key-modal.component';
import {RequestListService} from '../../shared/services/request-list.service';
import {Router, ActivatedRoute} from '@angular/router';
import {ResubmitRequestsModalComponent} from '../../shared/components/modals/resubmit-requests-modal/resubmit-requests-modal.component';
import {EditRequestsModalComponent} from '../../shared/components/modals/edit-requests-modal/edit-requests-modal.component';
import {Paginator} from 'primeng/paginator';
import {ExpandedRowComponent} from '../../shared/components/expanded-row/expanded-row.component';
import {Table, TableHeaderCheckbox, TableRowSelectEvent, TableRowUnSelectEvent, TableSelectAllChangeEvent} from 'primeng/table';
import {AddlinkConstant} from '../../constants/addlinkConstants';
import {CommonService} from '../../shared/services/common.service';
import {
  requestListDataRowColumns,
  requestListHeaderColumns,
  requestListSubHeaderDateColumns
} from '../../constants/requestColumns';
import {IRequest} from '../../constants/request.interface';
import {AccountNumberValidationService, LinkDelinkService, SharedConstant, SharedService} from '@ems/shared';
import {RequestListSubHeaderComponent} from '../../shared/components/request-list-sub-header/request-list-sub-header.component';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import * as temp from 'moment';
const moment = temp['default'];
import {DenyRequestsModalComponent} from '../../shared/components/modals/deny-requests-modal/deny-requests-modal.component';
import {ClientCentralNotesComponent} from '../../shared/components/modals/client-central-notes/client-central-notes.component';
import { RequestListActionMenuItems} from '../../models/request-list-action-menu';
import { UploadLOAModalComponent } from '../../shared/components/modals/upload-loa-modal/upload-loa-modal.component';
import { ModalService } from '../../shared/services/modal.service';
import { HttpResponse } from '@angular/common/http';

export interface IPaginator {
  totalPages: number;
  totalElements: number;
  size: number; // page size #of req per page
  currentPageNumber: number;
  numberOfElements: number;
}

@Component({
  selector: 'addlink-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})

export class RequestListComponent implements OnInit, OnDestroy, AfterViewChecked {

  public requests: IRequest[];
  sortColumn = 'requestId';
  sortOrder = 'desc';
  pageSize = 15;

  public pageObject: IPaginator = {
    size: this.pageSize,
    totalPages: 0,
    totalElements: 0,
    currentPageNumber: 0,
    numberOfElements: 0
  };

  public requestColumns: any[] = requestListHeaderColumns;
  public requestSubHeaderColumns: any[] = requestListSubHeaderDateColumns;
  public requestDataRowColumns: any[] = requestListDataRowColumns;

  public expandedRowFilter: string[];

  public filteredRequestColumns: any[];
  public filteredExpandedRowColumns: any[] = [];
  public dataRowListColumns: any[] = [];

  public selectedClientId: string;

  public selectedRequests: any[];

  public getAdlConst = AddlinkConstant;
  public clientInfoSubscribe: any;
  public clientInfo: any;
  clientName: string;
  businessUnitClass: string;
  requestListHeaderForm: UntypedFormGroup;
  getSharedConstant = SharedConstant;
  paginationCount: any = 0;

  @ViewChild('remarks', { static: true }) remarksViewChild: RemarksModalComponent;
  @ViewChild('editIndexKeyModal', { static: true }) editIndexKeyChild: EditIndexKeyModalComponent;
  @ViewChild('resubmitRequestsModal', { static: true }) resubitRequestsChild: ResubmitRequestsModalComponent;
  @ViewChild('denyRequestsModal', { static: true }) denyRequestsChild: DenyRequestsModalComponent;
  @ViewChild('editRequestsModal', { static: true }) editRequestsChild: EditRequestsModalComponent;
  @ViewChild('paginator', { static: true }) paginator: Paginator;
  @ViewChildren(ExpandedRowComponent) expandedrow: QueryList<ExpandedRowComponent>;
  @ViewChild('requestListTable', { static: true }) requestListTable: Table;
  @ViewChild(TableHeaderCheckbox) headerCheckbox: TableHeaderCheckbox;
  @ViewChild('toastMessage', { static: true }) msgToast: any;
  @ViewChildren(RequestListSubHeaderComponent) subHeader: QueryList<RequestListSubHeaderComponent>;
  @ViewChild('clientCentralNotes', { static: true }) clientCentralNotesChild: ClientCentralNotesComponent;
  @ViewChild('modalContainer', { read: ViewContainerRef, static: true }) containerRef!: ViewContainerRef;

  entitlements: any;
  isHidden: boolean;
  showMsg: any;
  showServiceError: any;
  toggle = false;
  showHeader = false;
  noRecordFiltermessage: any;
  accordionHeader = [];
  isExpanded = false;
  expandedRows = {};
  itemDataLength: number;
  subHeaderSchErrorMsg = [];
  isDisabled = false;
  filterState: any;
  selectedOptions = [];
  filterBtnDisable = false;
  filterBtnDisableForEmpName = false;
  filterBtnDisableForAcctNum = false;
  filterBtnDisableForMastAcctNum = false;
  statusDropdownData = [];
  filterClicked = false;
  subHeaderHasValue = false;
  storeFilterObj = {};
  takeActionMenuList = this.getAdlConst.takeActionMenuMsg.takeActionMenuTxt;
  selectedAction: any;
  externalAccess = false;
  usertype: any;
  hasADDLinkAccess = true;
  showActionItems = false;
  autoIndexEnabled: boolean;
  isDataTrackCalled = false;
  requestId: any;
  public getOrgId: any;
  businessUnit: any;
  bulkUploadBtnHide = false;

  @ViewChild('filterBtn') filterBtn: ElementRef;
  actionMenu: any[];
  showActionMenu: boolean;
  isSortingChanged = false;
  defaultSortDataField = { sortColumn: 'requestId', sortOrder: 'desc'};
  isRequestActionEnable: boolean;
  takeActionMenuListStatus = [];
  successMsg: string;
  // Multi-page selection tracking
  selectedRequestMap: Map<number, any> = new Map();
  errorMsg: any;
  @HostListener('document:click', [])
  onClick() { /* Capture the Click Event outside the function */
    if (!this.showActionMenu) {
      this.requestId = '';
    }
    this.showActionMenu = false;
  }

  constructor(public fb: UntypedFormBuilder, public requestListService: RequestListService, public addlinkService: AddlinkService, private commonService: CommonService, public el: ElementRef,
              private router: Router, private activatedRouter: ActivatedRoute, @Inject('commonConstants') public commonConstants, public sharedService: SharedService,
              @Inject('entitlementConst') public entitlementConst, @Inject('env') public environment, public linkDelinkService: LinkDelinkService,
              private acctNumValidationService: AccountNumberValidationService, public modalService: ModalService) {
    this.requestListService.showRequestListError.subscribe((data) => {
      this.showServiceError = data;
    });

    /*Update the Resubmited or Denided request response in the request-list table*/
    this.requestListService.updateRequest.subscribe((data) => {
      if (data) {
        this.updateResubmitRequests(data);
      }
    });
    this.autoIndexEnabled =  this.sharedService.applicationInfo.data.autoIndexEnabled;
  }

  ngOnDestroy(): void {
    if (this.clientInfoSubscribe && typeof this.clientInfoSubscribe.unsubscribe === 'function') {
      this.clientInfoSubscribe.unsubscribe();
    }
    if (this.requestListService.sourceAndStatusMultiselectValues && typeof this.requestListService.sourceAndStatusMultiselectValues.subscribe === 'function') {
      this.requestListService.sourceAndStatusMultiselectValues.next(null);
    }
    this.requestListService.clearMessage();

    if (this.sharedService.updatedDate && typeof this.sharedService.updatedDate.next === 'function') {
      this.sharedService.updatedDate.next('');
    }
    if (this.requestListService.showRequestListError && typeof this.requestListService.showRequestListError.next === 'function') {
      this.requestListService.showRequestListError.next(false);
    }
    this.sharedService.requestStatus = '';
    if (this.sharedService.requestStatusFilterObj) {
      this.sharedService.requestStatusFilterObj.liable407 = '';
    }
    if (this.msgToast && typeof this.msgToast.pushMessage === 'function') {
      this.msgToast.pushMessage('', '');
    }
  }

  /* Initialize component variables */
  ngOnInit() {
    this.modalService.registerViewContainerRef(this.containerRef);
    this.requestListHeaderForm = this.fb.group({
      requestId: [''],
      action: [''],
      status: [this.selectedOptions],
      internalStatus: [this.selectedOptions],
      employeeId: [''],
      employeeName: [''],
      acctNumber: [''],
      client: [''],
      masterAccountNbr: [''],
      dateTo: this.fb.group({
        date: ['']
      }),
      dateFrom: this.fb.group({
        date: ['']
      })
    });

    this.requestListService.clearMessage();
    this.showMsg = null;
    this.requestListService.getMessage().subscribe((data) => {
      this.showMsg = data.text ? data.text : null;
      if (this.showMsg && this.showMsg !== null) {
        this.requestListService.showRequestListError.next(false);
        setTimeout(() => {
          /*this.msgToast.pushMessage('success', this.showMsg);*/
        }, 1);
      }
    });
    this.expandedRowFilter = [
      'acctHolderName',
      'accountHolderAffiliation',
      'authAgentName',
      'commissionCode',
      'source',
      'createdBy',
      'createdDate',
      'completedBy',
      'completedDate',
      'liable407',
      'indexKey'
    ];
    this.takeActionMenu();
    this.addlinkService.userType.subscribe(result => {
      this.usertype = result;
    });
    this.addlinkService.userPolicy.subscribe(result => {
      const userPolicy = result.getValue();
      this.entitlements = userPolicy.entitlements;
      if (this.usertype === 'External') {
        this.isHidden = true;
      } else {
        this.isHidden = false;
      }

      this.filterRequestColumns();
    });

    this.clientInfoSubscribe = this.addlinkService.clientInformation.subscribe(clientInfo => {
      if (clientInfo !== null) {
        this.bulkUploadBtnHide = clientInfo.charitable ? true : false;
        this.isExpanded = false;
        this.showActionItems = this.sharedService.checkEntitlements(this.entitlementConst.navUUID.accountLinking.uuid, '', '');
        this.hasADDLinkAccess = this.sharedService.checkEntitlements(this.entitlementConst.navUUID.accountSummary.uuid, '', '');
        this.selectedClientId = clientInfo.clientId;
        this.requestListService.getOrgId = clientInfo.orgId;
        this.clientName = clientInfo.k4ClientName;
        this.businessUnitClass = clientInfo.businessUnit;
        this.clientInfo = clientInfo;
        this.sortColumn = 'requestId';
        this.sortOrder = 'desc';
        this.clientName !== 'All' ? (clientInfo.externalAccess && clientInfo.externalAccess === 'Y' ? this.externalAccess = true : this.externalAccess = false) : this.externalAccess = false;
        this.pageSize = 15;
        this.clickedClearBtn();
        this.showHeader = false;
        this.expandedRows = {};
        this.accordionHeader = [];
        this.takeActionMenuList = this.getAdlConst.takeActionMenuMsg.takeActionMenuTxt;
        this.takeActionMenu();
        this.selectedRequests = [];
        this.clearAllSelections();
        if (this.hasADDLinkAccess) {
          this.requestListService.getSourceAndStatusValue().subscribe(data => {
            this.requestListService.sourceAndStatusMultiselectValues.next(data);
          });
        }
        if (!this.sharedService.requestStatus) {
          this.toggle = false;
        }
        this.showHeader = false;
      }
    });

    this.onChanges();

    this.addlinkService.schErrorMsg.subscribe(value => {
      this.subHeaderSchErrorMsg = value;
    });

    /* Disable the Apply filter button if any error is present */
    this.requestListService.disableFilterButton.subscribe(value => {
      this.filterBtnDisable = value;
    });

    if (this.requests) {
      this.requests.length < this.pageObject.size ? this.itemDataLength = this.requests.length : this.itemDataLength = this.pageObject.size;
    }
  }

  ngAfterViewChecked() {
    const userType = this.sharedService.isInternalApp() ? this.getAdlConst.internalStatusTxt : this.getAdlConst.externalStatusTxt;
    const elementRef = this.el.nativeElement.querySelector('.p-multiselect-label');
    this.sharedService.setMultiSelectDefaultLabel(elementRef, this.requestListHeaderForm, userType, this.selectedOptions.length);
  }

  filterRequestColumns(): void {
    this.filteredRequestColumns = [];
    this.filteredExpandedRowColumns = [];
    for (const mainHeader of this.requestColumns) {

      this.filteredRequestColumns.push(mainHeader);
      if (this.isHidden && (mainHeader.field === this.getAdlConst.requestListMainHeaderFieldTxt.client || mainHeader.field === this.getAdlConst.internalStatusTxt)) {
        const index = this.filteredRequestColumns.findIndex(x => x.field === this.getAdlConst.requestListMainHeaderFieldTxt.client || x.field === this.getAdlConst.internalStatusTxt);
        this.filteredRequestColumns.splice(index, 1);
      } else if (!this.isHidden && mainHeader.field === this.getAdlConst.externalStatusTxt) {
        const index = this.filteredRequestColumns.findIndex(x => x.field === this.getAdlConst.externalStatusTxt);
        this.filteredRequestColumns.splice(index, 1);
      }
    }

    /*Pushed Sub headers into requestSubHeaderColumns*/
    for (const subHeader of this.requestSubHeaderColumns) {
      this.filteredExpandedRowColumns.push(subHeader);
    }

    /*Pushed Sub headers into requestDataRowColumns*/
    for (const subHeader of this.requestDataRowColumns) {
      this.dataRowListColumns.push(subHeader);
      /* eslint-disable-next-line max-len */
      if (this.isHidden && (subHeader.field === this.getAdlConst.requestListSubHeaderFieldTxt.liable407 || subHeader.field === this.getAdlConst.requestListSubHeaderFieldTxt.indexKey || subHeader.field === this.getAdlConst.requestListSubHeaderFieldTxt.commissionCode)) {
        /* eslint-disable-next-line max-len */
        const index = this.dataRowListColumns.findIndex(x => x.field === this.getAdlConst.requestListSubHeaderFieldTxt.liable407 || x.field === this.getAdlConst.requestListSubHeaderFieldTxt.indexKey || x.field === this.getAdlConst.requestListSubHeaderFieldTxt.commissionCode);
        this.dataRowListColumns.splice(index, 1);
      }
    }
  }

  sortColumnByField(e, field) {
    this.sharedService.clearErrorMessage();
    if (field === this.sortColumn) {
      this.sortOrder = this.sortOrder === 'desc' ? 'asc' : 'desc';
    } else {
      this.sortColumn = field;
      this.sortOrder = 'asc';
    }
    this.isSortingChanged = (this.defaultSortDataField.sortColumn === this.sortColumn && this.defaultSortDataField.sortOrder === this.sortOrder) ? false : true;
    this.requests = [];
    this.clearAllSelections();
    this.applyFilterCall();
  }

  resetPageObject() {
    this.pageObject = {
      size: this.pageSize,
      totalPages: 0,
      totalElements: 0,
      currentPageNumber: 0,
      numberOfElements: 0
    };
    this.requests = [];
    this.clearAllSelections();
    this.paginator.changePage(0);
    this.applyFilterCall();
  }

  refreshDataOnPageSizeChange() {
    this.sharedService.clearErrorMessage();
    this.resetPageObject();
  }

  public openRemarkPopup(e: any, requestId: string, accountNumber: string, status: string): void {
    this.remarksViewChild.openModal(e, requestId, accountNumber, status, this.showActionItems);
  }

  /**
   * Returns the count of actionable rows on the current page.
   * Bound to [totalRecords] on p-table so that PrimeNG's header checkbox
   * allSelected() check (selection.length === totalRecords) compares against
   * only selectable rows, not the full page row count.
   */
  get currentPageActionableCount(): number {
    if (!this.requests) return 0;
    return this.requests.filter(r => this.isRequestActionable(r)).length;
  }

  public isRequestActionable(request: any): boolean {
    const statusForActionable = this.isHidden ? request.status : request.internalStatus;
    if (this.statusCheckForActionMenu(statusForActionable)) {
      this.isRequestActionEnable = true;
      return true;
    } else {
      this.isRequestActionEnable = false;
      return false;
    }
  }
  public statusCheckForActionMenu(status: any): boolean {
    return this.takeActionMenuListStatus.includes(status);
  }

  public isEligibleForEdit(request: any): boolean {
    if (request.action === this.getAdlConst.linkTxt) {
      if (request.internalStatus === this.getAdlConst.statusLabel.validationMismatch || (request.internalStatus === this.getAdlConst.statusLabel.onHold &&
        request.liable407 === 'Yes' && (request.indexKey === null || request.indexKey === '' || request.indexKey === 'null') && !this.isHidden)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  public editRequestPopup(e: any, request: any): void {
    const clientId = this.selectedClientId !== null ? this.selectedClientId : request.client.clientId;
    request.disableIcon = true;
    if (request.internalStatus === this.getAdlConst.statusLabel.validationMismatch) {
      this.editRequestsChild.openModal(e, request.requestId, request.acctNumber, request.orgId, request.authAgentId, request.masterAccountNbr,
        request.employeeFirstName, request.employeeLastName, request.accountOwnerFirstName, request.accountOwnerLastName, request.accountHolderAffiliation, request.source);
    } else {
      this.editIndexKeyChild.openModal(e, request.requestId, request.acctNumber, this.clientInfo.orgId);
    }
  }

  public enableResubmit(): boolean {
    return !!this.selectedRequestMap?.size;
  }

  public bulkSubmit(): void {
    /* Set isDTBtnClicked value to true, generate the data track value with 'linkid-lc' . */
    this.sharedService.isDTBtnClicked = true;
    this.sharedService.loadDataTrackValue('upload');
    this.sharedService.parentPage = '../request-list';
    this.router.navigate(['../addlink-upload'], {relativeTo: this.activatedRouter});
  }

  public takeActionPopup(event, actionValue): void {
    const events = event?.originalEvent ? event?.originalEvent : event;
    this.sharedService.clearErrorMessage();
    if (!this.sharedService.isInternalApp()) {
      this.sharedService.gutTracking('adobe-lc_resubmit|fireonce');
    } else if (!this.isDataTrackCalled) {
      this.isDataTrackCalled = true;
      this.sharedService.gutTracking('adobe-lc_takeaction|fireonce');
    }
    const requestIds: any[] = [];
    let validationMismatch = 0;
    let dbsActionNeeded = 0;
    let requestDenied = 0;
    let missingIndexKey = 0;
    for (const request of this.selectedRequestMap.values()) {
      if (((actionValue === this.getAdlConst.takeActionMenuMsg.resubmitTxt && request.internalStatus !== this.getAdlConst.statusLabel.validationMismatch && request.internalStatus !== this.getAdlConst.statusLabel.dbsActionNeeded &&
        ((request.internalStatus === this.getAdlConst.statusLabel.onHold && (request.liable407 === 'Yes' && this.sharedService.isInternalApp() && request.indexKey !== null && request.indexKey !== '' && request.indexKey !== 'null') || request.liable407 === 'No') ||
          (request.internalStatus === this.getAdlConst.statusLabel.onHold && (request.liable407 === '' && !this.sharedService.isInternalApp() && (request.indexKey === null || request.indexKey === '' || request.indexKey === 'null'))))) ||
        (actionValue === this.getAdlConst.takeActionMenuMsg.denyTxt && request.internalStatus !== this.getAdlConst.statusLabel.requestDenied) ||
        (actionValue === this.getAdlConst.takeActionMenuMsg.resolveTxt
           || (actionValue === this.getAdlConst.takeActionMenuMsg.uploadLOATxt || 
            actionValue === this.getAdlConst.takeActionMenuMsg.approveLOATxt || 
            actionValue === this.getAdlConst.takeActionMenuMsg.declineLOATxt))) && this.isRequestActionable(request)) {
        requestIds.push(request.requestId);
      } else if (request.internalStatus === this.getAdlConst.statusLabel.validationMismatch) {
        validationMismatch++;
      } else if (request.internalStatus === this.getAdlConst.statusLabel.dbsActionNeeded) {
        dbsActionNeeded++;
      } else if (request.internalStatus === this.getAdlConst.statusLabel.requestDenied) {
        requestDenied++;
      } else if (request.internalStatus === this.getAdlConst.statusLabel.onHold &&
        ((request.liable407 === 'Yes' && (request.indexKey === null || request.indexKey === '' || request.indexKey === 'null') && this.sharedService.isInternalApp()) ||
          (request.liable407 === '' && (request.indexKey === null || request.indexKey === '' || request.indexKey === 'null') && !this.sharedService.isInternalApp()))) {
        missingIndexKey++;
      }
    }
    setTimeout(() => {
      if (actionValue === this.getAdlConst.takeActionMenuMsg.resubmitTxt) {
        this.resubitRequestsChild.openModal(events, requestIds, validationMismatch, dbsActionNeeded, missingIndexKey, this.requestListTable, this.clientInfo.orgId);
      } else if (actionValue === this.getAdlConst.takeActionMenuMsg.denyTxt) {
        this.denyRequestsChild.openModal(events, requestIds, requestDenied, this.requestListTable, this.getAdlConst.denyRequestModalLabel, this.clientInfo.orgId);
      } else if (actionValue === this.getAdlConst.takeActionMenuMsg.resolveTxt) {
        this.denyRequestsChild.openModal(events, requestIds, 0, this.requestListTable, this.getAdlConst.resolveRequestModalLabel, this.clientInfo.orgId);
      } else if (actionValue === this.getAdlConst.takeActionMenuMsg.uploadLOATxt && this.clientInfo.businessUnit === this.getSharedConstant.dbsBUText) {
        const obj = {
          event: event,
          requestIds: requestIds,
          title: this.getAdlConst.uploadRequestLOAModalLabel,
          orgId: this.clientInfo.orgId,
        }
        this.openModal(obj);
      } else if (actionValue === this.getAdlConst.takeActionMenuMsg.approveLOATxt && this.clientInfo.businessUnit === this.getSharedConstant.dbsBUText) {
        this.approveOrDeclineLOA(this.getAdlConst.takeActionMenuMsg.approveLOATxt);
      } else if (actionValue === this.getAdlConst.takeActionMenuMsg.declineLOATxt && this.clientInfo.businessUnit === this.getSharedConstant.dbsBUText) {
        this.approveOrDeclineLOA(this.getAdlConst.takeActionMenuMsg.declineLOATxt);
      }
      this.selectedAction = '';
    }, 1);
  }
  public updateSingleRequest(requestObject: any): void {
    for (const request of this.requests) {
      if (request.requestId === requestObject.requestId) {
        request.status = requestObject.status ? requestObject.status : request.status;
        request.internalStatus = requestObject.status ? requestObject.internalStatus : request.internalStatus;
        request.indexKey = requestObject.indexKey ? requestObject.indexKey : request.indexKey;
        request.employeeFirstName = requestObject.employeeFirstName ? requestObject.employeeFirstName : request.employeeFirstName;
        request.employeeLastName = requestObject.employeeLastName ? requestObject.employeeLastName : request.employeeLastName;
        request.accountOwnerFirstName = requestObject.accountOwnerFirstName ? requestObject.accountOwnerFirstName : request.accountOwnerFirstName;
        request.accountOwnerLastName = requestObject.accountOwnerLastName ? requestObject.accountOwnerLastName : request.accountOwnerLastName;
        request.accountHolderAffiliation = requestObject.accountHolderAffiliation ? requestObject.accountHolderAffiliation : request.accountHolderAffiliation;
        request.disableIcon = requestObject.disableIcon;

        this.isEligibleForEdit(request);
        if (requestObject.assignedToFirstName !== 'null' && requestObject.assignedToLastName !== 'null') {
          request.assignedToFirstName = requestObject.assignedToFirstName;
          request.assignedToLastName = requestObject.assignedToLastName;

        } else if (requestObject.assignedToFirstName === 'null' && requestObject.assignedToLastName === 'null') {
          request.assignedToFirstName = '';
          request.assignedToLastName = '';
        }
        if (requestObject.completedDate !== 'null' && requestObject.completedBy !== 'null') {
          request.completedDate = requestObject.completedDate;
          request.completedBy = requestObject.completedBy;
        } else if (requestObject.completedDate === 'null' && requestObject.completedBy === 'null') {
          request.completedDate = '';
          request.completedBy = '';

        }
        request.createdBy = requestObject.createdBy;
        request.createdDate = requestObject.createdDate;

        this.assignAuthAgents(request, requestObject);
        this.clearAllSelections();
        this.updateTakeActionMenuStatus();
        if (this.expandedrow) {
          const rows: ExpandedRowComponent[] = this.expandedrow.toArray();
          for (const row of rows) {
            row.filterRequest();
          }
        }
        break;
      }
    }
  }

  public updateResubmitRequests(requestObject: any): void {
    if (this.requests) {
      for (const request of this.requests) {
        if (request.requestId === requestObject.requestId) {
          request.status = this.isHidden ? requestObject.status : requestObject.internalStatus;
          request.internalStatus = this.isHidden ? requestObject.status : requestObject.internalStatus;
          this.assignAuthAgents(request, requestObject);

          if (requestObject.completedDate !== 'null' && requestObject.completedBy !== 'null') {
            request.completedDate = requestObject.completedDate;
            request.completedBy = requestObject.completedBy;
          } else if (requestObject.completedDate === 'null' && requestObject.completedBy === 'null') {
            request.completedDate = '';
            request.completedBy = '';

          }
          request.createdBy = requestObject.createdBy;
          request.createdDate = requestObject.createdDate;

          if (requestObject.employeeFirstName !== 'null' && requestObject.employeeLastName !== 'null'
            && requestObject.accountOwnerFirstName !== 'null' && requestObject.accountOwnerLastName !== 'null') {
            request.employeeFirstName = requestObject.employeeFirstName;
            request.employeeLastName = requestObject.employeeLastName;
            request.accountOwnerFirstName = requestObject.accountOwnerFirstName;
            request.accountOwnerLastName = requestObject.accountOwnerLastName;
          } else {
            request.employeeFirstName = '';
            request.employeeLastName = '';
            request.accountOwnerFirstName = '';
            request.accountOwnerLastName = '';
          }
          request.accountHolderAffiliation = requestObject.accountHolderAffiliation;
          if (requestObject.assignedToFirstName !== 'null' && requestObject.assignedToLastName !== 'null') {
            request.assignedToFirstName = requestObject.assignedToFirstName;
            request.assignedToLastName = requestObject.assignedToLastName;

          } else if (requestObject.assignedToFirstName === 'null' && requestObject.assignedToLastName === 'null') {
            request.assignedToFirstName = '';
            request.assignedToLastName = '';
          }
        }
        this.clearAllSelections();
        this.updateTakeActionMenuStatus();
        if (this.expandedrow) {
          const rows: ExpandedRowComponent[] = this.expandedrow.toArray();
          for (const row of rows) {
            row.filterRequest();
          }
        }
        this.selectedRequests = [];
      }
    }
  }

  public assignAuthAgents(request: any, requestObject: any): void {
    if (request.authAgent !== null) {
      request.authAgent.authAgentLastName = requestObject.authAgentLastName;
      request.authAgent.authAgentFirstName = requestObject.authAgentFirstName;
    }
  }

  toggleFctn() {
    this.toggle = !this.toggle;
    this.showHeader = !this.showHeader;
    if (this.accordionHeader.length !== 0) {
      this.showHeader = true;
    } else {
      this.showHeader = false;
    }
    this.requestListHeaderForm.patchValue({status: this.businessUnitClass === 'RBS' ? this.selectedOptions.slice(0, 1) : this.selectedOptions});
    this.requestListHeaderForm.patchValue({internalStatus: this.businessUnitClass === 'RBS' ? this.selectedOptions.slice(0, 1) : this.selectedOptions});
  }

  showFilterHeaders(rowData) {
    if (this.accordionHeader.indexOf(rowData) === -1) {
      this.accordionHeader.push(rowData);
      this.showHeader = true;
    } else {
      this.accordionHeader.splice(this.accordionHeader.indexOf(rowData), 1);
      if (this.accordionHeader.length === 0) {
        this.showHeader = false;
      }
    }
  }

  clickedClearBtn() {
    this.resetForm(false);
    this.resetPageObject();
  }

  resetForm(resetApiCall = true) {
    this.sortColumn = 'requestId';
    this.sortOrder = 'desc';
    this.isSortingChanged = false;
    this.sharedService.requestStatus = this.filterClicked ? '' : this.sharedService.requestStatus;
    this.requestListService.clearClicked.emit(true);
    this.sharedService.clearErrorMessage();
    this.requestListHeaderForm.reset();
    this.setDefaultValueToForm();
    this.filterClicked = false;
    if (resetApiCall) {
      this.resetPageObject();
    }
  }

  setDefaultValueToForm() {
    this.statusDropdownData = [];
    if (this.selectedOptions.length === 0) {
      this.requestListService.sourceAndStatusMultiselectValues.subscribe(data => {
        if (data !== null) {
          data.data.status.all.forEach(statusName => {
            const obj = {label: statusName, value: statusName};
            this.statusDropdownData.push(obj);
          });
          this.statusDropdownData.forEach((item) => this.selectedOptions.push(item.value));
        }
      });
    }
    const newObj = {label: this.getAdlConst.valueLabelAll, value: this.getAdlConst.valueLabelAll};
    this.requestListHeaderForm.patchValue({action: newObj});
    this.requestListHeaderForm.patchValue({status: this.businessUnitClass === 'RBS' ? this.selectedOptions.slice(0, 1) : this.selectedOptions});
    this.requestListHeaderForm.patchValue({internalStatus: this.businessUnitClass === 'RBS' ? this.selectedOptions.slice(0, 1) : this.selectedOptions});

    if (this.businessUnitClass === 'RBS') {
    this.requestListHeaderForm.get('internalStatus').disable();
    }
  }

  expandAll() {
    if (!this.isExpanded) {
      this.showHeader = true;
      this.requests.forEach(data => {
        this.expandedRows[data.requestId] = true;
        this.accordionHeader.push(data);
      });
    } else {
      this.showHeader = false;
      this.expandedRows = {};
      this.accordionHeader = [];
    }
    this.isExpanded = !this.isExpanded;
  }

  onRowExpand() {
    if (Object.keys(this.expandedRows).length === this.itemDataLength) {
      this.isExpanded = true;
    }
  }

  onRowCollapse() {
    if (Object.keys(this.expandedRows).length === 0) {
      this.isExpanded = false;
    }
  }

  onChanges(): void {
    this.requestListHeaderForm.get('requestId').valueChanges.subscribe((requestIdValue) => {
      if (requestIdValue && this.requestListHeaderForm.get('requestId').valid) {
        this.isDisabled = !this.isDisabled;
        this.filterState = 'disable';
      } else {
        this.isDisabled = !this.isDisabled;
        this.filterState = 'enable';
      }
      Object.keys(this.requestListHeaderForm.controls).forEach((controlName) => {
        if (controlName !== 'requestId') {
          this.requestListHeaderForm.controls[controlName][this.filterState]();
          if (this.filterState === 'disable') {
            this.requestListHeaderForm.controls[controlName].reset();
          }
        }
      });
      this.requestListService.disableForm.emit(this.filterState);
      if (this.filterState === 'disable') {
        this.setDefaultValueToForm();
      }
    });

    this.requestListHeaderForm.get('action').valueChanges.subscribe(value => {
      this.requestListService.sourceAndStatusMultiselectValues.subscribe(data => {
        this.statusDropdownData = [];
        if (data !== null) {
          if (value && value.value === this.getAdlConst.linkTxt) {
            data.data.status.link.forEach(statusName => {
              const obj = {label: statusName, value: statusName};
              this.statusDropdownData.push(obj);
            });
          } else if (value && value.value === this.getAdlConst.delinkMasterAccModal.delinkTxt) {
            data.data.status.delink.forEach(statusName => {
              const obj = {label: statusName, value: statusName};
              this.statusDropdownData.push(obj);
            });
          } else {
            data.data.status.all.forEach(statusName => {
              const obj = {label: statusName, value: statusName};
              this.statusDropdownData.push(obj);
            });
          }
          this.selectedOptions = [];
          this.statusDropdownData.forEach((item) => this.selectedOptions.push(item.value));
          this.requestListHeaderForm.patchValue({status: this.businessUnitClass === 'RBS' ? this.selectedOptions.slice(0, 1) : this.selectedOptions});
          this.requestListHeaderForm.patchValue({internalStatus: this.businessUnitClass === 'RBS' ? this.selectedOptions.slice(0, 1) : this.selectedOptions});
        }
      });
    });

    this.requestListHeaderForm.get('employeeId').valueChanges.subscribe(value => {
      this.requestListHeaderForm.controls.employeeId.setValue(value ? value.toUpperCase() : '', { emitEvent: false });
      if (this.requestListHeaderForm.get('employeeId').errors?.emsStartSpacePattern !== false) {
        this.filterBtnDisable = this.sharedService.isValueLengthGreaterThan2(value);
      }
    });

    this.requestListHeaderForm.get('employeeName').valueChanges.subscribe(value => {
       if (this.requestListHeaderForm.get('employeeName').errors?.emsStartSpacePattern !== false){
      this.filterBtnDisableForEmpName = this.sharedService.isValueLengthGreaterThan2(value);
       }
    });

    this.requestListHeaderForm.get('masterAccountNbr').valueChanges.subscribe(value => {
      this.filterBtnDisableForMastAcctNum = this.acctNumValidationService.validateAccountNumber(value);
    });

    this.requestListHeaderForm.get('acctNumber').valueChanges.subscribe(value => {
      this.filterBtnDisableForAcctNum = this.acctNumValidationService.validateAccountNumber(value);
    });
  }

  clickedFilterBtn() {
    this.requestListService.filterClicked.emit(true);
    this.filterClicked = true;
  }

  applyFilter(event: any) {
    /* Clear Service Error */
    this.filterClicked = true;
    this.sharedService.requestStatus = '';
    this.sharedService.clearErrorMessage();
    const localUpdatedFormValues = this.requestListHeaderForm.getRawValue();
    const isStatusAll = this.statusDropdownData.every((val, index) => val.value === localUpdatedFormValues.internalStatus[index]);
    const isExtStatusAll = this.statusDropdownData.every((val, index) => val.value === localUpdatedFormValues.status[index]);
    const subHeaderFormValues = event;
    const fromDate = [];
    if (subHeaderFormValues.requestListSubHeaderForm.createdDate !== undefined && subHeaderFormValues.requestListSubHeaderForm.createdDate !== '' && subHeaderFormValues.requestListSubHeaderForm.createdDate !== null) {
      subHeaderFormValues.requestListSubHeaderForm.createdDate.forEach(date => {
        fromDate.push(date);
      });
    }
    const isSourceAll = subHeaderFormValues.sourceDropdownData.every((val, index) => val.value === subHeaderFormValues.requestListSubHeaderForm.source[index]);
    const accountNumWithNoDash = localUpdatedFormValues.acctNumber ? localUpdatedFormValues.acctNumber.replace(/-/g, '') : '';
    const formFilterObj: any = {
      acctNumber: accountNumWithNoDash?.trim(),
      action: localUpdatedFormValues.action ? localUpdatedFormValues.action.value.trim() : '',
      orgId: this.clientInfo.orgId === 0 ? null : this.clientInfo.orgId,
      clientIds: [],
      fromDate: fromDate.length > 0 ? moment(fromDate[0]).format('MM/DD/YYYY') : '',
      liable407: subHeaderFormValues.requestListSubHeaderForm.liable407 ? subHeaderFormValues.requestListSubHeaderForm.liable407.value : '',
      masterAccountNbr: localUpdatedFormValues.masterAccountNbr ? localUpdatedFormValues.masterAccountNbr.trim() : '',
      requestId: localUpdatedFormValues.requestId ? localUpdatedFormValues.requestId : '',
      /* eslint-disable-next-line max-len */
      source: subHeaderFormValues.requestListSubHeaderForm.source ? (isSourceAll && (this.businessUnitClass === 'DBS' || this.businessUnitClass === 'SPS') ? subHeaderFormValues.requestListSubHeaderForm.source = [this.getAdlConst.valueLabelAll] : subHeaderFormValues.requestListSubHeaderForm.source) : [],
      /* eslint-disable-next-line max-len */
      status: (!this.isHidden && localUpdatedFormValues.internalStatus) ? (isStatusAll && (this.businessUnitClass === 'DBS' || this.businessUnitClass === 'SPS') ? localUpdatedFormValues.internalStatus = [this.getAdlConst.valueLabelAll] : localUpdatedFormValues.internalStatus) : (this.isHidden && localUpdatedFormValues.status) ? (isExtStatusAll ? localUpdatedFormValues.status = [this.getAdlConst.valueLabelAll] : localUpdatedFormValues.status) : [],
      toDate: fromDate.length > 0 ? moment(fromDate[1]).format('MM/DD/YYYY') : '',
      employeeId: localUpdatedFormValues.employeeId ? localUpdatedFormValues.employeeId.trim() : '',
      employeeLastName: localUpdatedFormValues.employeeName ? localUpdatedFormValues.employeeName.trim() : ''
    };
    this.updateformValues(formFilterObj);
    this.storeFilterObj = formFilterObj;
    this.pageObject.currentPageNumber = 0;
    this.paginator.changePage(0);
    this.applyFilterCall();
  }

  applyFilterCall() {
    this.resetStatusFilters();
    if (this.sharedService.requestStatus) {      
      this.toggle = true;
      this.filterClicked = true;
      let fromDateValue = '';
      let toDateValue = '';
      let statusValue = this.sharedService.requestStatus;
      let actionValue = this.getAdlConst.valueLabelAll;
      let sourceValue = this.getAdlConst.valueLabelAll;
      if (this.sharedService.requestStatus === this.getAdlConst.statusLabel.requireIndexing || this.sharedService.requestStatus === this.getAdlConst.clientCentralLinks || this.sharedService.requestStatus === this.getAdlConst.clientCentralDelinks) {        
        const getCurrentDay = moment().tz('America/New_York').day();
        const getCurrentDate = new Date(moment().tz('America/New_York').format('MM-DD-YYYY'));
        if (this.sharedService.requestStatus === this.getAdlConst.statusLabel.requireIndexing) {
          if (getCurrentDay === 1) {
            fromDateValue = moment(getCurrentDate, 'MM/DD/YYYY').subtract(3, 'days').format('MM/DD/YYYY');
          } else {
            fromDateValue = moment(getCurrentDate, 'MM/DD/YYYY').subtract(1, 'days').format('MM/DD/YYYY');
          }
          toDateValue = moment(getCurrentDate, 'MM/DD/YYYY').subtract(1, 'days').format('MM/DD/YYYY');
        } else {
          fromDateValue = toDateValue = moment(getCurrentDate, 'MM/DD/YYYY').format('MM/DD/YYYY');
        }
        if (this.autoIndexEnabled === true && (statusValue === this.getAdlConst.statusLabel.requireIndexing)) {
          statusValue = this.getAdlConst.statusLabel.requireIndexing;
        } else {
          statusValue = this.getAdlConst.statusLabel.complete;
        }
        actionValue = this.sharedService.requestStatus === this.getAdlConst.clientCentralDelinks ? this.getAdlConst.delinkMasterAccModal.delinkTxt : this.getAdlConst.linkTxt;
        sourceValue = this.sharedService.requestStatus === this.getAdlConst.statusLabel.requireIndexing ? this.getAdlConst.sourceLabelTxt.aDDLinkDBS : this.getAdlConst.sourceLabelTxt.clientCentral;
      }
      if (this.sharedService.requestStatus === this.getAdlConst.statusLabel.onHold ||
        this.sharedService.requestStatus === this.getAdlConst.statusLabel.validationMismatch ||
        this.sharedService.requestStatus === this.getAdlConst.statusLabel.dbsActionNeeded ||
        this.sharedService.requestStatus === this.getAdlConst.statusLabel.errorLOA ||
        this.sharedService.requestStatus === this.getAdlConst.statusLabel.pendingLOA ||
        this.sharedService.requestStatus === this.getAdlConst.statusLabel.inReviewLOA) {
        this.requestListHeaderForm.markAsDirty();
      }
      this.sharedService.requestStatusFilterObj = {
        status: this.businessUnitClass === 'RBS' ? [this.getAdlConst.statusLabel.complete] : [statusValue],
        action: actionValue,
        source: this.businessUnitClass === 'RBS' ? [this.getAdlConst.sourceLabelTxt.clientCentral] : [sourceValue],
        liable407: this.sharedService.requestStatus === this.getAdlConst.statusLabel.requireIndexing ? 'Yes' : '',
        fromDate: fromDateValue,
        toDate: toDateValue,
        orgId: this.clientInfo.orgId === 0 ? null : this.clientInfo.orgId
      };
      const newObj = {
        label: this.sharedService.requestStatusFilterObj.action,
        value: this.sharedService.requestStatusFilterObj.action
      };
      this.requestListHeaderForm.patchValue({
        status: this.filterClicked ? this.sharedService.requestStatusFilterObj.status : this.getAdlConst.valueLabelAll,
        internalStatus: this.filterClicked ? this.sharedService.requestStatusFilterObj.status : this.getAdlConst.valueLabelAll,
        action: this.filterClicked ? newObj : this.getAdlConst.valueLabelAll
      });
      this.storeFilterObj = this.sharedService.requestStatusFilterObj;
    } else if (!this.filterClicked && (this.sharedService.requestStatus === '' || this.sharedService.requestStatus === undefined)) {
      const filterObj = {
        status: this.businessUnitClass === 'RBS' ? [this.getAdlConst.statusLabel.complete] : [this.getAdlConst.valueLabelAll],
        action: this.getAdlConst.valueLabelAll,
        source: this.businessUnitClass === 'RBS' ? [this.getAdlConst.sourceLabelTxt.clientCentral] : [this.getAdlConst.valueLabelAll],
        orgId: this.clientInfo.orgId === 0 ? null : this.clientInfo.orgId
      };
      this.storeFilterObj = filterObj;
    }
    if (this.hasADDLinkAccess) {
      // Apply filter API call should be made only when user has access to view the request list page, if user doesn't have access then show no records found message without making API call.
      this.requestListData();
    }
  }

  populateData(result) {
    this.requests = result.pagerequests.content;
    this.requests.forEach(item => {
      item.masterAccountNbr = (item.masterAccountLabel === null) ? ((item.masterAccountNbr !== null) ? ((item.masterAccountSubType !== null && item.masterAccountSubType !== undefined) ? item.masterAccountNbr + ' (' + item.masterAccountType + '-' + item.masterAccountSubType + ') '
        : item.masterAccountNbr + ' (' + item.masterAccountType + ') ') : '') : (item.masterAccountNbr !== null) ? (item.masterAccountLabel + '\n' + item.masterAccountNbr) : '';
      item.disableIcon = false;
    });
    this.pageObject.currentPageNumber = result.pagerequests.number;
    this.pageObject.totalElements = this.sharedService.totalElementsWithCommas(result.pagerequests.totalElements);
    this.paginationCount = result.pagerequests.totalElements;
    this.pageObject.totalPages = result.pagerequests.totalPages;
    this.pageObject.size = this.pageSize;
    
    // Restore selections for current page
    this.restoreSelectionsForCurrentPage();
  }

  paginate(e) {
    this.showHeader = false;
    this.expandedRows = {};
    this.accordionHeader = [];
    this.isExpanded = false;
    if (this.pageObject.currentPageNumber !== e.page) {
      this.pageObject.currentPageNumber = e.page;
      this.sharedService.clearErrorMessage();
      this.applyFilterCall();
    }
  }

  public openNotesPopup(e: any, requestId: string, accountNumber: string, status: string): void {
    this.clientCentralNotesChild.openModal(e, requestId, accountNumber);
  }

  updateformValues(formVals) {
    this.sharedService.updatedDate.next(formVals.fromDate ? {name: 'Require Indexing', fromDate: formVals.fromDate, toDate: formVals.toDate } : '');
  }

  onActionButtonKeydown(event: KeyboardEvent, rowData: any, fieldValue?: any): void {
    this.sharedService.openActionMenuOnKeydown(event, () => {
      this.showActionMenu = true;
      this.requestId = fieldValue;
      this.formData(rowData);
    });
  }

  onActionMenuClick(event: any, rowData: any) {
    const actionItem = event.item?.label;
    const domEvent = event.originalEvent || event;
    this.sharedService.clearErrorMessage();
    if (actionItem === this.getAdlConst.requestListFilterFields.requestrulesLanding.client) {
      this.openNotesPopup(domEvent, rowData.requestId, rowData.acctNumber, rowData.status);
    } else if (actionItem === this.getAdlConst.requestListFilterFields.requestrulesLanding.remarks) {
      this.openRemarkPopup(domEvent, rowData.requestId, rowData.acctNumber, rowData.status);
    } else if (actionItem === this.getAdlConst.requestListFilterFields.requestrulesLanding.edit && !(!this.isEligibleForEdit(rowData) || rowData.disableIcon === true)) {
      this.editRequestPopup(domEvent, rowData);
    } else if (actionItem === this.getAdlConst.requestListFilterFields.requestrulesLanding.downloadLOA) {
      this.requestListService.downloadLOAFile(rowData.requestId, this.clientInfo.orgId).subscribe({
        next: (response: HttpResponse<Blob>) => {
          const contentDisposition = response.headers.get('content-disposition');
          let filename = `LOA_${rowData.requestId}.pdf`;          // fallback
          if (contentDisposition) {
            const filenameMatch = contentDisposition.match(/filename="([^"]+)"/i);
            filename = filenameMatch ? filenameMatch[1] : filename;
          }
          const url = window.URL.createObjectURL(response.body);
          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        },
       error: (error : any) => {
          if (error.error instanceof Blob) {
            error.error.text().then(text => {
              const errorResponse = JSON.parse(text);
              this.msgToast.pushMessage('error', errorResponse.errorResponse.errorMessage);
            });
          }
        }
      });
    }
  }

  formData(rowData) {
    const actionItem = RequestListActionMenuItems;
    actionItem.forEach(data => {
      if (data.label === 'Edit' && (!this.isEligibleForEdit(rowData) || rowData.disableIcon === true)) {
        data.disabled = true;
      } else {
        data.disabled = false;
      }
    });

    if (this.sharedService.isInternalApp()) {
      this.actionMenu = actionItem.filter(item => item.label !== this.getAdlConst.requestListFilterFields.requestrulesLanding.edit);
      // Show Download LOA only for internal users with LOAs In-Review status 
      if (rowData.status !== this.getAdlConst.statusLabel.inReviewLOA || this.verifyClient()) {
        this.actionMenu = this.actionMenu.filter(item => item.label !== this.getAdlConst.requestListFilterFields.requestrulesLanding.downloadLOA);
      }
    } else {
      this.actionMenu = actionItem.filter(item => item.label === this.getAdlConst.requestListFilterFields.requestrulesLanding.remarks);
    }
    
    if (this.showActionItems) {
      actionItem.forEach(data => {
        if (data.label === 'Edit' && !data.disabled) {
          // disable Edit button if status is validation mismatch AND showHistoricalView is true
          const disableEditForHistoricalValidationMismatch =
            rowData.internalStatus === this.getAdlConst.statusLabel.validationMismatch &&
            this.sharedService.showHistoricalView.value;

          if (disableEditForHistoricalValidationMismatch) {
            data.disabled = true;
          }
          // Always add the Edit button to the menu, but it will be disabled if conditions are met
          if (!data.disabled || disableEditForHistoricalValidationMismatch) {
            this.actionMenu.push(data);
          }
        }
      });
    }
    this.bindMenuCommands(rowData);
    return this.actionMenu;
  }

  private bindMenuCommands(rowData: any): void {
    this.actionMenu = this.actionMenu.map(item => ({...item, command: (event) => this.onActionMenuClick(event, rowData)}));
  }
  requestListData(message?: any) {
    this.requestListService.applyFilter(this.pageObject.currentPageNumber, this.pageSize, this.sortColumn, this.sortOrder, this.clientInfo.orgId, this.storeFilterObj).subscribe(result => {
      if (result.data !== null && result.data.pagerequests !== null) {
        this.populateData(result.data);
      } else {
        this.requests = result.data;
        this.noRecordFiltermessage = result.errorResponse.errorMessage;
        this.pageObject.totalElements = 0;
        this.paginationCount = 0;
      }
      if (message) {
        const uploadSuccess = message === 'success';
        const successMsg = uploadSuccess
          ? `${this.getSharedConstant.bulkUpload.fileSubmitted}<br>${this.getSharedConstant.bulkUpload.uploadLoaSuccessMsg}`
          : message;
        this.msgToast.pushMessage('success', successMsg);
      } else {
        this.msgToast.pushMessage('', '');
      }
      this.updateTakeActionMenuStatus();
    });
  }
  // method: onload of request list landing page to filter list of enable checkboxs
  takeActionMenu() {
    const baseStatuses = [
      this.getAdlConst.statusLabel.onHold,
      this.getAdlConst.statusLabel.validationMismatch,
      this.getAdlConst.statusLabel.dbsActionNeeded,
    ];
    // to external user if the client is All Clients then Take Action menu options will be hidden for the selected requests in the request list page 
    // because All Clients request can be taken action by internal user only
    // external user cannot take action on All Clients request even though those requests are visible to external user in request list page.
    if (!this.sharedService.isInternalApp() && this.clientName === 'All') {
      this.takeActionMenuListStatus = baseStatuses;
    } else {
      this.takeActionMenuListStatus = [
        ...baseStatuses,
        this.getAdlConst.statusLabel.errorLOA,
        this.getAdlConst.statusLabel.pendingLOA];
      // LOA In-Review status should be added in Take Action menu options for internal users 
      // because only internal user can see the request with LOA In-Review status and take action on those requests Accept and Download LOA options until the review is completed.
      // but external user can see the request with LOA In-Review status in request list page and cannot take action on those requests until the review is completed. 
      // So, we disabled checkbox LOA In-Review status from Take Action menu options for external users.
      if (this.sharedService.isInternalApp()) {
        this.takeActionMenuListStatus.push(this.getAdlConst.statusLabel.inReviewLOA);
      }
    }

    return this.takeActionMenuListStatus;
  }
  onRowSelect(rowSelectedEvent: TableRowSelectEvent) {
    // Add selected request to tracking
    if (rowSelectedEvent.data && rowSelectedEvent.data.requestId) {
      this.selectedRequestMap.set(rowSelectedEvent.data.requestId, rowSelectedEvent.data);
    }
    this.updateTakeActionMenuStatus();
    this.filterTakeActionMenu();
    this.requestListTable.cd.markForCheck();
  }

  onRowUnselect(event: TableRowUnSelectEvent) {
    // Remove unselected request from tracking
    if (event.data && event.data.requestId) {
      this.selectedRequestMap.delete(event.data.requestId);
    }
    this.updateTakeActionMenuStatus();
    this.filterTakeActionMenu();
    this.selectedRequests = this.requestListTable.selection ? [...this.requestListTable.selection] : [];
    if (!this.selectedRequests || this.selectedRequests.length === 0) {
      // Check if there are any selections on other pages
      if (this.selectedRequestMap.size === 0) {
        this.requestListTable.selection = [];
        this.selectedRequests = [];
        this.requestListTable.updateSelectionKeys();
        this.requestListTable.tableService.onSelectionChange();
      }
    }
    this.requestListTable.cd.markForCheck();
  }

  onHeaderCheckboxClick(event: any) {
    // Determine if we're selecting or deselecting current page
    const actionableRequestsOnPage = this.requests.filter(r => this.isRequestActionable(r));
    const currentPageSelected = actionableRequestsOnPage.every(r => this.selectedRequestMap.has(r.requestId));

    if (!currentPageSelected && actionableRequestsOnPage.length > 0) {
      // Select all actionable rows on current page
      this.selectAllRequests(true);
    } else {
      // Deselect all rows on current page
      this.selectAllRequests(false);
    }
    this.requestListTable.cd.markForCheck();
  }

  onSelectAll(event: TableSelectAllChangeEvent) {
    if (event.checked) {
      // Select all actionable rows on current page only
      const actionableRows = this.requests.filter(r => this.isRequestActionable(r));
      this.requestListTable.selection = [...actionableRows];
      this.selectedRequests = [...actionableRows];
      // Add to tracking Map
      actionableRows.forEach(row => this.selectedRequestMap.set(row.requestId, row));
    } else {
      // Deselect all rows on current page only
      const currentPageRequestIds = this.requests.map(r => r.requestId);
      currentPageRequestIds.forEach(id => this.selectedRequestMap.delete(id));
      this.selectedRequests = [];
      this.requestListTable.selection = [];
    }
    this.selectAllRequests(event.checked);
    this.filterTakeActionMenu();
    this.requestListTable.cd.markForCheck();
  }

  filterTakeActionMenu() {
    // Start with all menu options
    this.takeActionMenuList = this.getAdlConst.takeActionMenuMsg.takeActionMenuTxt;
    // to filter requestid from selected status and 
    // to show Take Action menu options based on the status of the selected request in the request list page.
    const actionableRequests = Array.from(this.selectedRequestMap.values()).filter(e => this.isRequestActionable(e));
    const hasLOAStatus = actionableRequests.some(request =>
      [
        this.getAdlConst.statusLabel.pendingLOA,
        this.getAdlConst.statusLabel.inReviewLOA,
        this.getAdlConst.statusLabel.inProcessLOA,
        this.getAdlConst.statusLabel.errorLOA
      ].includes(request.status)
    );

    const isDBS = this.clientInfo.businessUnit === this.getSharedConstant.dbsBUText;
    const isAllClients = this.clientInfo.orgId === 0;
    const isExternalUser = !this.sharedService.isInternalApp();

    if (!hasLOAStatus) {
      if (isExternalUser && isDBS) {
        // External DBS users: show only Resubmit
        this.takeActionMenuList = this.takeActionMenuList.filter(menu =>
          menu.value === this.getAdlConst.takeActionMenuMsg.resubmitTxt
        );
      } else {
        // Others: show all except Upload LOA
        this.takeActionMenuList = this.takeActionMenuList.filter(menu =>
          menu.value !== this.getAdlConst.takeActionMenuMsg.uploadLOATxt &&
          menu.value !== this.getAdlConst.takeActionMenuMsg.approveLOATxt &&
          menu.value !== this.getAdlConst.takeActionMenuMsg.declineLOATxt
        );
      }
      return;
    }

    // If has LOA status requests
    if (isAllClients || !isDBS) {
      // All Clients or Non-DBS: show only Deny
      this.takeActionMenuList = this.takeActionMenuList.filter(menu =>
        menu.value === this.getAdlConst.takeActionMenuMsg.denyTxt
      );
    } else if (isExternalUser && isDBS) {
      // External DBS users: show only Upload LOA
      this.takeActionMenuList = this.takeActionMenuList.filter(menu =>
        menu.value === this.getAdlConst.takeActionMenuMsg.uploadLOATxt
      );
    } else if(actionableRequests.some(request => request.status === this.getAdlConst.statusLabel.inReviewLOA) && this.sharedService.isInternalApp()) {
      // if user select LOA In-Review, hiding Upload LOA option from Take Action menu 
      // because if the request is in In-Review LOA status then user cannot upload LOA document until the review is completed.
      this.takeActionMenuList = this.takeActionMenuList.filter(menu => 
        menu.value !== this.getAdlConst.takeActionMenuMsg.uploadLOATxt && 
        menu.value !== this.getAdlConst.takeActionMenuMsg.resolveTxt &&
        menu.value !== this.getAdlConst.takeActionMenuMsg.resubmitTxt
      );
    } else {
      // Internal DBS users: show Deny and Upload LOA
      this.takeActionMenuList = this.takeActionMenuList.filter(menu =>
        menu.value === this.getAdlConst.takeActionMenuMsg.denyTxt ||
        menu.value === this.getAdlConst.takeActionMenuMsg.uploadLOATxt
      );
    }
  }

  // method to open upload LOA modal when user clicks on Upload LOA option in Take Action menu
  openModal(obj): void {
    this.modalService.open(UploadLOAModalComponent, obj)
      .subscribe(result => {
        if (result === 'success') {
          this.requestListData('success');
          this.clearAllSelections();
          this.updateTakeActionMenuStatus();
        }
      });
  }
  // to verify if the client is All Clients or not before showing the Take Action menu options for the selected requests in the request list page.
  // If the client is All Clients then Take Action menu options will be hidden for the selected requests in the request list page.
  verifyClient() {
    return (this.clientName === 'All' || this.clientInfo.businessUnit !== this.getSharedConstant.dbsBUText);
  }
  // to disable the status based on checkbox selection.
  updateTakeActionMenuStatus() {

    const status = this.toLoadStatusForTakeActionMenu();

    // rowselect and rowunselect will come here to enable or disable requestIds.
    const selectedStatuses = Array.from(this.selectedRequestMap.values()).filter(e => this.isRequestActionable(e)).map(e => e.internalStatus);
    if (selectedStatuses.some(s => status.loaStatus.includes(s))) {
      this.takeActionMenuListStatus = status.loaStatus;
    } else if (selectedStatuses.some(s => status.status.includes(s))) {
      this.takeActionMenuListStatus = status.status;
    } else if (selectedStatuses.some(s => status.loaReviewStatus.includes(s)) && this.sharedService.isInternalApp()) {
      this.takeActionMenuListStatus = status.loaReviewStatus;
    } else {
      this.takeActionMenuListStatus = [
        ...status.status,
        ...status.loaStatus,
        ...status.loaReviewStatus
      ];
      if (!this.sharedService.isInternalApp()) {
        this.takeActionMenuListStatus = this.takeActionMenuListStatus.filter(item => item !== this.getAdlConst.statusLabel.inReviewLOA);
      }
      if (!this.sharedService.isInternalApp() && this.clientName === 'All') {
        this.takeActionMenuListStatus = this.takeActionMenuListStatus.filter(item => item !== this.getAdlConst.statusLabel.pendingLOA && item !== this.getAdlConst.statusLabel.errorLOA);
      }
    }
  }
  selectAllRequests(checked: boolean) {
    const statusCheck = this.toLoadStatusForTakeActionMenu();
    if (checked) {
      this.takeActionMenuListStatus = statusCheck.status;
    } else {
      if (this.selectedRequestMap.size === 0) {
        this.takeActionMenuListStatus = [
          ...statusCheck.status,
          ...statusCheck.loaStatus,
          ...statusCheck.loaReviewStatus
        ];
      } else {
        this.updateTakeActionMenuStatus();
      }
    }
  }

  toLoadStatusForTakeActionMenu() {
    const status = {
      status: [
        this.getAdlConst.statusLabel.validationMismatch,
        this.getAdlConst.statusLabel.onHold,
        this.getAdlConst.statusLabel.dbsActionNeeded
      ],
      loaStatus: [
        this.getAdlConst.statusLabel.pendingLOA,
        this.getAdlConst.statusLabel.errorLOA
      ],
      loaReviewStatus: [
        this.getAdlConst.statusLabel.inReviewLOA
      ]
    };
    return status;
  }

  // Multi-page selection helper methods
  clearAllSelections(): void {
    this.selectedRequestMap.clear();
    this.selectedRequests = [];
    if (this.requestListTable) {
      this.requestListTable.selection = [];
    }
  }

  restoreSelectionsForCurrentPage(): void {
    if (!this.requests || this.requests.length === 0) {
      this.selectedRequests = [];
      if (this.requestListTable) {
        this.requestListTable.selection = [];
      }
      return;
    }

    // Find which requests on current page are in the selected Map
    // MUST use exact object references from this.requests
    const selectedOnThisPage = this.requests.filter(request =>
      this.selectedRequestMap.has(request.requestId) && this.isRequestActionable(request)
    );

    // Update the Map with current page request objects
    selectedOnThisPage.forEach(req => {
      this.selectedRequestMap.set(req.requestId, req);
    });

    // Set both to the SAME array reference
    this.selectedRequests = selectedOnThisPage;
    this.requestListTable.selection = selectedOnThisPage;

    // Wait for DOM to be ready, then update PrimeNG's internal state
    setTimeout(() => {
      // Rebuild selection keys from scratch
      this.requestListTable.selectionKeys = {};
      selectedOnThisPage.forEach(req => {
        this.requestListTable.selectionKeys[String(req.requestId)] = 1;
      });

      // Calculate if all actionable rows on this page are selected
      const actionableRows = this.requests.filter(r => this.isRequestActionable(r));
      const allSelected = actionableRows.length > 0 &&
        actionableRows.every(r => this.selectedRequestMap.has(r.requestId));

      // Fire onSelectionChange first — PrimeNG's subscription in TableHeaderCheckbox
      // will recompute its own checked value from allSelected().
      this.requestListTable.tableService.onSelectionChange();
      this.requestListTable.cd.detectChanges();

      // Override AFTER onSelectionChange so PrimeNG's recomputed (wrong) value is overwritten.
      // PrimeNG's allSelected() fails here because it checks all rows including non-actionable.
      if (this.headerCheckbox) {
        this.headerCheckbox.checked = allSelected;
        this.headerCheckbox.cd.detectChanges();
      }
    }, 5);
  }
  // to reset filters
  resetStatusFilters() {
    const statusControl = Array.from(this.selectedRequestMap.values()).map(e => e.internalStatus);
    const statusFilterValue = this.requestListHeaderForm.get('internalStatus').value;
    const statusFilter = Array.isArray(statusFilterValue) ? statusFilterValue : [];
    const isAllSelected = this.requestListHeaderForm.get('status').value === this.getAdlConst.valueLabelAll;

    if (!isAllSelected && statusControl.some(s => !statusFilter.includes(s))) {
      this.clearAllSelections();
    }
  }
  //LOA IN-Review status Approve and Decline LOA API call from Take Action menu
  approveOrDeclineLOA(action: string) {
    const reqPayload = {
      operation: action === this.getAdlConst.takeActionMenuMsg.approveLOATxt ? this.getAdlConst.takeActionMenuMsg.approveLOARequest : this.getAdlConst.takeActionMenuMsg.declineLOARequest,
      index: '',
      requestIds: Array.from(this.selectedRequestMap.keys()) // selected request ids from map which are actionable for approve or decline LOA action
    }
     this.requestListService.uploadOrApproveOrDeclineLOA(reqPayload, this.clientInfo.orgId).subscribe({
      next: (response: any) => {
        const successMessage = action === this.getAdlConst.takeActionMenuMsg.approveLOATxt ? this.getAdlConst.takeActionMenuMsg.approveLOASuccessMsg : this.getAdlConst.takeActionMenuMsg.declineLOASuccessMsg;
        this.requestListData(successMessage);
        this.clearAllSelections();
        this.updateTakeActionMenuStatus();
      },
      error: (error) => {
        this.errorMsg = error?.message || 'An error occurred during the operation. Please try again.';
      }
    });
  }

}
